import {env} from 'next-runtime-env';
import {Envs} from 'types/env';

export const getEnv = <T extends keyof Envs>(key: T) => {
    return env(key) as Envs[T];
};
